// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qao5W","content":"styles_content__3vWXH"};